import React from "react";
import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

function Toast({ open, message, severity, duration, handleClose }) {
  let alertText = message;
  if (!message && severity === "error") {
    alertText = "Something went wrong";
  }
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      open={open}
      onClose={handleClose}
      autoHideDuration={4000}
    >
      <Alert severity={severity} variant="filled" onClose={handleClose}>
        {alertText}
      </Alert>
    </Snackbar>
  );
}

export default Toast;
